<template>
  <div class="mb-3">
    <label :for="id">
      {{ label }}
      <span v-if="info" class="text-primary"
        ><i
          class="fa fa-info-circle"
          title="Adicionar la aprobación de la (MAE)"
        ></i
      ></span>
      <span v-if="required" class="text-danger">*</span>
    </label>
    <vee-field
      :name="name"
      v-slot="{ field, handleChange }"
      :rules="required ? 'required' : ''"
    >
      <div class="position-relative">
        <input
          :id="id"
          ref="fileInput"
          type="file"
          :accept="accept"
          :multiple="false"
          @change="(event) => handleUpload(event, handleChange)"
          class="d-none"
        />
        <button
          type="button"
          @click="triggerFileInput"
          class="btn btn-secondary w-100 d-flex align-items-center justify-content-center"
          style="min-height: 40px; max-width: 100%"
        >
          <i class="fa fa-upload me-2"></i>
          <span class="text-truncate">
            {{ selectedFile ? selectedFile.name : "Seleccionar archivo" }}
          </span>
        </button>

        <div v-if="selectedFile" class="mt-2">
          <div
            class="d-flex align-items-center justify-content-between p-2 bg-light rounded border"
          >
            <div class="d-flex align-items-center">
              <i class="fa fa-file me-2 text-primary"></i>
              <span
                class="small text-dark"
                style="
                  display: block;
                  max-width: 100px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
              >
                {{ selectedFile.name }}
              </span>
              <span class="badge bg-secondary ms-2">{{
                formatFileSize(selectedFile.size)
              }}</span>
            </div>
            <button
              type="button"
              @click="removeFile(handleChange)"
              class="btn btn-sm btn-danger"
              title="Eliminar archivo"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />

    <div v-if="existingFile && !hasNewFile" class="mt-2">
      <small class="text-muted">
        Archivo actual:
        <a :href="existingFile.url" target="_blank" class="text-primary">
          {{ existingFile.name }}
        </a>
      </small>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { ErrorMessage } from "vee-validate";

const fileInput = ref(null);
const selectedFile = ref(null);

const props = defineProps({
  id: String,
  name: String,
  label: String,
  info: Boolean,
  required: Boolean,
  accept: {
    type: String,
    default: "*",
  },
  existingFile: {
    type: Object,
    default: null,
  },
});

// Computed para saber si hay un archivo nuevo
const hasNewFile = computed(() => !!selectedFile.value);

const triggerFileInput = () => {
  fileInput.value?.click();
};

const handleUpload = (event, handleChange) => {
  const file = event.target.files[0];
  if (file) {
    selectedFile.value = file;
    handleChange(file);
  }
};

const removeFile = (handleChange) => {
  selectedFile.value = null;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
  handleChange(null);
};

const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

const getCurrentFile = () => {
  return selectedFile.value;
};

const hasFile = () => {
  return !!selectedFile.value;
};

const clearFile = () => {
  selectedFile.value = null;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
};

defineExpose({
  getCurrentFile,
  hasFile,
  clearFile,
  selectedFile: selectedFile.value,
});
</script>
